import { apiClient } from '@/core/api/client'
import type { 
  Customer, 
  Affaire, 
  ApiResponse 
} from '../types/search.types'

export const searchAPI = {
  // Customer search - matching old adminAPI.searchCustomers
  async searchCustomers(query: string): Promise<ApiResponse<{ customers: Customer[] }>> {
    try {
      const params = new URLSearchParams()
      params.append('searchQuery', query)
      
      const response = await apiClient.get(`/api/admin/customers/search?${params}`)
      return response as ApiResponse<{ customers: Customer[] }>
    } catch (error) {
      throw new Error('Failed to search customers')
    }
  },

  // Get customer expertises - matching old fmAPI.getClientData
  async getCustomerExpertises(fmClientId: string): Promise<ApiResponse<{ affairs: Affaire[] }>> {
    try {
      const response = await apiClient.get(`/api/fm/client/${fmClientId}`)
      return response as ApiResponse<{ affairs: Affaire[] }>
    } catch (error) {
      throw new Error('Failed to fetch customer expertises')
    }
  },

  // Search affaire by ID - matching old adminAPI.searchAffaire
  // Returns either single affaire (dossier_id match) or multiple affaires (address match)
  async searchAffaire(affaireId: string): Promise<ApiResponse<{
    affaire?: Affaire;
    affaires?: Affaire[];
    matchType?: 'dossier_id' | 'address';
  }>> {
    try {
      const params = new URLSearchParams()
      params.append('affaireId', affaireId)

      const response = await apiClient.get(`/api/admin/affaire/search?${params}`)
      return response as ApiResponse<{
        affaire?: Affaire;
        affaires?: Affaire[];
        matchType?: 'dossier_id' | 'address';
      }>
    } catch (error) {
      throw new Error('Failed to search affaire')
    }
  },

  // Search contacts by phone number (for voicemail caller identification)
  async searchContactsByPhone(phone: string): Promise<ApiResponse<{ contacts: Customer[], count: number }>> {
    try {
      const params = new URLSearchParams()
      params.append('phone', phone)

      const response = await apiClient.get(`/api/admin/contacts/search-by-phone?${params}`)
      return response as ApiResponse<{ contacts: Customer[], count: number }>
    } catch (error) {
      throw new Error('Failed to search contacts by phone')
    }
  }
}